<div class="map">
    <div #map style="width:100%;height:100%"></div>
</div>
